/**
 * Platform detection helpers.
 *
 * Wraps Capacitor's runtime checks so the rest of the app can branch on
 * "are we inside the native iOS shell?" without importing Capacitor directly.
 * On the web (PWA/browser) these all report web, so existing behavior is
 * unchanged.
 */
import { Capacitor } from '@capacitor/core';

/** True when running inside a native Capacitor shell (iOS or Android). */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/** True only inside the native iOS app. */
export function isNativeIOS(): boolean {
  return Capacitor.getPlatform() === 'ios';
}

/** 'ios' | 'android' | 'web' */
export function getPlatform(): string {
  return Capacitor.getPlatform();
}
